<template>
  <generic-modal
    @close="closeOfferDetailsModal('dismiss')"
    :height="'auto'"
    :width="'100vw'"
    :paddingTop="'0px !important'"
    :padding="'0 0 0 0'"
    :background="'transparent'"
    :backgroundBody="'white'"
    :zIndex="'99999'"
    class="sticky-bottom show cust-modal-wrap lg-screen-centered"
  >
    <template v-slot:header>
      <offer-details-header></offer-details-header>
    </template>
    <template v-slot:body>
      <offer-details-body
        :data-title="dataTitle"
        :data-description="dataDescription"
        :data-coupon-code="dataCouponCode"
        :data-expiry-date="dataExpiryDate"
        :data-savings-msg="dataSavingsMsg"
        :data-theme="dataTheme"
        :data-is-applicable="dataIsApplicable"
      ></offer-details-body>
    </template>
    <template v-slot:footer>
      <div></div>
    </template>
  </generic-modal>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";

export default {
  name: "OfferDetailsPopup",
  components: {
    GenericModal: defineAsyncComponent(() => import("./GenericModal.vue")),
    OfferDetailsHeader: defineAsyncComponent(
      () => import("./OfferDetailsHeader.vue"),
    ),
    OfferDetailsBody: defineAsyncComponent(
      () => import("./OfferDetailsBody.vue"),
    ),
  },
  props: {
    dataTitle: { required: false, default: "" },
    dataDescription: { required: false, default: "" },
    dataCouponCode: { required: false, default: "" },
    dataExpiryDate: { required: false, default: "Nov 1,2023" },
    dataSavingsMsg: { required: false, default: "" },
    dataTheme: { required: true, default: "#911987" },
    dataIsApplicable: { required: true, default: true },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    closeOfferDetailsModal(source) {
      this.$store.commit(
        keyMapsMutation.UPDATE_OFFER_DETAILS_MODAL_FLAG,
        false,
      );
      if (window.location.href?.includes("/offers")) {
        Utility.updateOfferUrl();
      }
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    //
  },
};
</script>

<style></style>
